import { SVGProps } from 'react';

const Bank = (props: SVGProps<SVGSVGElement>) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  (<svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 18 18"
    {...props}
    data-palette="Bank">
    <path
      fill="var(--main-text-primary)"
      stroke="var(--main-bg-surface)"
      strokeWidth="0.4"
      d="M.667 15.667h16.666v1.666H.667v-1.666ZM2.333 9H4v5.833H2.333V9ZM6.5 9h1.667v5.833H6.5V9Zm3.333 0H11.5v5.833H9.833V9ZM14 9h1.667v5.833H14V9ZM.667 4.833 9 .667l8.333 4.166v3.334H.667V4.833Zm1.666 1.03V6.5h13.334v-.637L9 2.53 2.333 5.863ZM9 5.667A.833.833 0 1 1 9 4a.833.833 0 0 1 0 1.667Z"
    />
  </svg>)
);

export default Bank;
